import React from 'react';
import PropTypes from 'prop-types';

const Next = ({navigateNext, children, className, disabled}) => (
    <button onClick={navigateNext}
        className={['wizard-btn', 'btn-next', className].join(' ').trim()}
        disabled={disabled}>{children}</button>
);

Next.propTypes = {
    children: PropTypes.any,
    navigateNext: PropTypes.func,
    className: PropTypes.string,
    disabled: PropTypes.bool
};

Next.defaultProps = {
    navigateNext: () => null,
    disabled: false
};

export default Next;
